import React, {useEffect} from 'react';
import { KoFormBuilder } from 'packages';
import styles from './curd.module.scss';

function RemarkCrud({ form, product }) {


  useEffect(()=>{
    form?.resetFields();
  },[]);

  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: product,
    colon: true,
    fields: [
      {
        key: 'description', label: 'Remarks (For Internal Use)' , placeholder: 'Ex: apple', colSpan: 4
      }
    ]
  };
  return (
    <div className={styles.wrapper}>
      <KoFormBuilder form={form} meta={meta} />
    </div>
  );
};

export default RemarkCrud;